export default __webpack_public_path__ + "77469565b2e2d9aea0663c83e2083df4.png";